import React, { useEffect } from 'react';
import bg from '../assets/images/el.jpg';
import Footer from './Footer';

const AboutUs = () => {
  // Scroll to the top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white text-black">
      {/* Hero Image Section */}
      <section className="relative w-full">
        <img
          src={bg}
          alt="Hero Image"
          className="w-full h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="text-4xl md:text-7xl font-ettlora text-white text-center">
            About Us
          </div>
        </div>
      </section>
      <main className="container mx-auto py-12 px-4 bg-white text-black">
        <section className="mb-12">
          <h2 className="text-3xl font-greatvibes mb-4">Elayone Music</h2>
          <p className="text-lg mb-4">
          Elayone Music is a Christian bible-based assembly that started in December 2007 by the Holy Spirit through a young man called “SANGWA Serge” who began with around three members. Ever since, Elayone Music kept growing in faith, in serving God and in Christ likeness.
The main activity was  “Worshiping God (Elayone Music)” and through it all, God did wonders whenever Elayone has ever been to minister. The Gatherings and choir practices used to take place at small open space in front of the Pioneer's home. Though by then Elayone looked small, it impacted lives and led many to Christ. Teenagers dropping off alcohol and drugs, sick people getting healed, hope rising back in hearts, people being filled with the Holy Spirit and changing radically and so many more by God’s grace.
Since then with the lead of the holy spirit Elayone Is growing day by day.          </p>
        
        </section>
        <section className="mb-12">
          <h2 className="text-3xl font-greatvibes mb-4">Vision & Mission</h2>
          <p className="text-lg mb-4">
          Elayone Music believes in God the Father who loves us unconditionally, The Son Jesus Christ who gave his life, died for our sins and rose again to give to all who believe in Him an eternal life and we believe in the Holy Spirit who strengthens the Body of Christ(the Church) and intercede for it.
          We believe in the Bible which is the True Word of God.          </p>
          <p className="text-lg mb-4">
          <strong>Vision: </strong> Isaiah 61:1-5 “Prepare the Bride of Christ”
           “Let the whole world know and live for Jesus Christ” Matthew 28: 19-20          </p>
       
          <p className="text-lg mb-4">
          <strong>Mission: </strong>Exodus 27:20  “Using our God-given gifts to enlighten the World through the Holy Spirit”</p>
        
        
          <p className="text-lg mb-4">

          “Through love, we impact the community with social activities, worship and biblical principles”
          </p>        </section>
       
        <section>
          <p className="text-lg mb-4">
          We would love to hear or connect with you          </p>
          <p className="text-lg mb-2">
            <strong>Email:</strong>{' '}
            <a href="#" className="text-black hover:underline">
              info@elayonemusic.org
            </a>
          </p>
      
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutUs;
